export default "/assets/webshop/img/no-product-image.jpg?454d62c301adc1352405bdd20ec3916f";